export default {
  meeting:{
    applyrecurring: '變更將套用至新的循環行程，歷史會議不會受到影響。',
    recurrenceDescribeTwo: '從{start}開始，直到{end}，每{loopPulse}週的{week}重複一次',
    wanttodeletethemeetingfollowTwo: '刪除目前選取的會議及其後續循環會議？',
    loopCycleSelectTips: '請選擇每週星期幾重複',

    export: '匯出',
    exportMeetingFileFuncTipsTitle: '匯出提示',
    exportMeetingFileFuncTipsContentOne: '目前未設定篩選條件，系統將預設匯出本年度的會議資料。',
    exportMeetingFileFuncTipsContentTwo: '如需匯出其他時間段的會議資料，請先設定篩選條件後再匯出。',

    myMeetingSearch: '我的會議',
    meetingTimeSearch: '會議時間',
    meetingRoomsSearch: '會議室',

    Recurring: '重複：',
    wanttodeletethemeetingfollow: '確定要刪除此會議及後續所有會議嗎？',
    endTimeCannotBeforeBeginTime: '結束日期不能早於開始日期',
    Thismeeting: '本次會議',
    Recurringmeeting: '週期會議',
    Checkin: '簽到：',
    checkinTip: '啟用後，與會者可以掃描會議室預約二維碼進行簽到。',
    Recurrence_Setrecurrence: '設定重複',
    Recurrence_Start: '開始',
    Recurrence_RepeatEvery: '重複間隔',
    Recurrence_Week: '週',
    Recurrence_end: '結束',
    recurrenceDescribe: '每{week}重複一次，從{start}開始，直到{end}',
    Recurrence_DoesnotRepeat: '不重複',
    Recurrence_Weekly: '每週',

    AddressBookUser: '用戶',
    AddressBookPhonebook: '通訊錄',

    RoomByPeopleNum1: '2人及以下',
    RoomByPeopleNum2: '3-6人',
    RoomByPeopleNum3: '7-10人',
    RoomByPeopleNum4: '11-15人',
    RoomByPeopleNum5: '16-20人',
    RoomByPeopleNum6: '21-30人',
    RoomByPeopleNum7: '30人以上',

    whoAreBound: '已綁定系統帳號的人員，將在系統日程中看到該會議。填寫郵箱的人員，將透過郵件收到會議通知。如需接收郵件通知，可前往【個人資料】中完善郵箱資訊。',

    AttendessMeeting: '參會人：',
    SelectAttendessMeetingTip: '選擇參會人',

    MeetingFilter: '會議篩選',
    HostedbyMe: '我發起的',
    Invitedby: '我參與的',
    Otherby: '其它',

    "AddressIsDuplicated": "聯絡人邮箱重複",
    "meetingExpired": "已過期",
    titlePhoneFormat: '電話只能填寫數字和()+，-',
    selectField: '請選擇文件',
    Limit255: '文件名不允許超過255個字符',
    "nameLimit25": "名字不能超過25個字符",
    "emailLimit50": "郵箱不能超過50個字符",
    "emailFormatError": "請輸入正確的郵箱格式",
    "phoneLimit11": "電話號碼最多只能輸入11位數字",
    ParticipantsEmail:'參會人郵箱：',
    listIsEmpty:'列表為空',
    Startimporting:'開始上傳',
    Selectfile:'選擇文件',
    Importfile:'導入文件',
    ImportfileTip:'*僅支援匯入 Outlook 格式的 CSV（.csv）或 vCard（.vcf）格式檔案。',
    addParticipants:'添加參會人',
    multiselectdeselect:'刪除標籤提示',
    multiselectselected:'已選提示',
    enterOrSelectALabel:'選擇參會人郵箱',
    deleTitleContact:'確定刪除聯絡人嗎？',
    delTitleContactContent:'刪除聯絡人?',
    deleteContactTitle:'請選擇要刪除的聯絡人',
    editcontact:'編輯聯絡人',
    Name:'名字',
    email:'郵箱',
    telephoneNumber:'電話',
    Addcontact:'添加聯絡人',
    Importcontactfile:'導入聯絡人',
    AddressBook:'通訊錄',
    Participants:'參與會議者：',

    bindTipContent:'當前組織已綁定第三方日曆，請前往Outlook/Teams預定會議。',
    Productupdatenews:'有新版本更新發布',
    bookingPerson: '預定人',
    "DeleteMeeting": "刪除會議",
    "wanttodeletethemeeting": "您確定要刪除會議嗎？",
    "hasbeendeleted": "會議已被刪除",
    "theMeetingWasAborted": "提前結束會議",
    "theMeetingWasAbortedContent": "您確定要提前結束會議嗎？",
    "determineTheAbortTask": "提前結束會議",
    "theMeetingEndedEarly": "會議已提前結束。",
    with:'與',
    Other:'等',
    tasks:'個任務',
    conflict:'衝突',
    meetConflicts:'以下會議時間衝突：',
    itIsNotAllowedToSelectThePastTime:'不允許選擇過去的時間',
    selected:'已選擇',
    noOverFive:'選擇的會議室不能超過5個',
    approvalOpinions:'審批意見',
    beyondTheTimeLimitItCannotBeSelected:'超過時間不可選擇',
    startMonth:'開始月份',
    to:'至',
    stopMonth:'結束月份',
    didnTStart:'未開始',
    ONGOING:'進行中',
    ENDED:'已結束',
    hasBeen:'已被',
    booking:'預定',
    Approval:'需審批',
    MeetingRoom:'會議室',
    AllRoom:'全部會議室',
    Available:'可預訂',
    Initiate:'發起會議',
    MeetingApproval:'會議審批',
    PreviousMonth:'上個⽉',
    Today:'今天',
    NextMonth:'下個⽉',
    YearMonth:'年/⽉',
    TimeDisplay:'時刻顯示',
    MeetingTitleAbbreviation:'會議標題縮寫',
    InitiateMeeting:'發起會議',
    PendingMeetings:'待參加會議',
    AllMeetings:'全部會議',
    noMeetings:'暫無待參加的會議',
    NotStarted:'未開始',
    Organizer:'組織⼈',
    MeetingDateTime:'會議時間',
    MeetingLocation:'會議地點',
    MeetingSubject:'會議主題',
    Invited:'邀請⼈數',
    PeopleAccepted:'⼈員接受情況',
    EditMeeting:'修改會議',
    CancelMeeting:'取消會議',
    InitiateEditMeeting:'發起/編輯會議',
    Subject:'主題',
    Presenter:'主講⼈ ： ',
    DateTime:'⽇期和時間：',
    TimeAndZone:'時區',
    Attendees:'參加者',
    Addrequiredattendees:'添加必需的參加者',
    SelectRooms:'選擇會議室',
    Reminder:'提醒',
    Remindbeforestart:'開始前提醒',
    Confirm:'確認',
    topic:'主題:',
    topicplace:'新的會議名稱：',
    speaker:'主講人',
    speakerplace:'請輸入主講人資訊',
    DateAndTime:'⽇期和時間：',
    TimeZone:'時區',
    EndDate:'End date',
    Rooms:'會議室： ',
    Notes:'備註：',
    MeetingRoomApproval:'會議室審批',
    PendingApproval:'待審批',
    Approved:'已審批',
    nopendingapprovals:'暫無待處理的審批單',
    Applicant:'申請⼈',
    UsageTime:'使⽤時間',
    ApprovalResult:'審批結果',
    ApprovalComments:'審批意⻅',
    Approve:'通過',
    Reject:'拒絕',
    Search:'搜索',
    Filter:'篩選',
    scanTheQRCodeToSignIn:'掃碼籤到',
  },
  NPS:{
    Relay:'中繼器',
    RelaySettings:'中繼器設置',
    DevicePower:'設備電源控制',
    DeviceElevation:'升降控制',
    LinageWithNPSPower:'與NPS電源的聯動',
    PresentationSwitch:'展示切換',
    Duplicate:'複製',
    LinkagewithNPSPowe:'與NPS電源聯動',
    npsTooltip:'只有將 PC 主機切換到 HDMI OUT 1 才能呼叫 USB 裝置。',
    nmpTooltip:'點擊“複製”按鈕可將螢幕內容複製至其他顯示器，使顯示效果同步顯示在多個螢幕上。',
  },
  textTemplate:{
    template2513:'消防應急廣播',
    template2514:'請大家根據疏散示意圖，從安全出口方向、消防避難方向疏散到安全地方。',
    moreTemplate:'範本已達上限',
    add:'新增',
    SetTemplate:'預設範本',
    Emergency:'緊急情況',
    General:'普通',
    BroadcastDevices:'播放設備：',
    selectBroadcastDevices:'請選擇播放設備',
    All:'全部',
    AddTemplate:'新增範本',
    EditTemplate:'編輯範本',
    deleteTemplage:'確定要刪除選擇的範本嗎？',
    title:'刪除範本',
    selectTemplage:'請選擇範本！',
    DeleteCancelled:'已取消刪除！',
    DeletedSuccessfully:'刪除成功！',
    noData:'暫無範本可使用，點擊右上角可新增範本',
    TemplateTitle:'範本標題：',
    BroadcastType:'播放類型：',
    BroadcastTypeDialog:'播放類型：',
    selectBroadcastType:'請選擇播放類型',
    BroadcastDuration:'廣播時間長度：',
    BroadcastDevice:'播放設備：',
    BroadcastContent:'播放內容：',
  },
  common:{
    mediaTimeStateNotifyErrorTitle: '出錯了！',
    mediaTimeStateNotifyErrorContent: '您的服務已到期，請聯繫您的代理商及時續約。',
    mediaTimeStateNotifyWarnTitle: '請注意！',
    mediaTimeStateNotifyWarnContent: '您當前為試用狀態，最多只可向三臺裝置發送廣播命令，請檢查您勾選的設備數量。',
    mediaTimeStateNotifySuccessTitle: '續約成功',
    mediaTimeStateNotifySuccessContent: '您的服務已經可以正常使用。謝謝。',
    company:'公司：',
    tableAddress:'地址：',
    createTime:'創建時間：',
    email:'電子郵件：',
    phone:'電話：',
    Trial:'試用',
    TrialWorkstation:'您當前為試用狀態。最多只可向三臺裝置發送廣播命令。',
    Normal:'正常',
    NormalWorkstation:'您的服務有效期為',
    to:'至',
    Advent:'即將到期',
    AdventWorkstationOne:'您的服務即將於',
    AdventWorkstationTwo:'到期，請及時聯繫您的代理商辦理續約以免影響正常使用。',
    Expired:'逾期',
    ExpiredWorkstation:'您的服務已到期，請聯繫您的代理商及時續約。',
  },
  route: {
    dashboard: '後臺管理',
    i18n: 'I18n',
    Devices:'設備控制',
    Broadcast:'廣播控制',
    Schedule:'任務',
    Resources:'存儲管理',
    Live:'直播控制',
    meetings:'會議預約',
  },
  navbar: {
    updates:'最新更新',
    logOut: '登出',
    screenfull: '全螢幕',
    oprofile:'個人資料',
    settings:'設定',
    language:'語言',
    BackTianwa:'返回天蛙雲',
    newUserGuide:'新用戶指引',
  },
  feedback:{
    Feedback:'意見回饋',
    email:'請留下電子郵件以便我們快速回覆您的意見和建議',
    content:'歡迎留言幫助我們改善產品功能，感謝您的意見和建議。',
    submit:'送出',
    emailNoEmpty:'電子郵件不能空白',
    emailTrueRule:'請輸入正確的電子郵件格式',
    contentNoEmpty:'內容不能空白',
    feedbackSuccess:'回饋成功',
    feedbackFailed:'回饋失敗',
    emailNoChinese:'電子郵件不能有中文',
    emailLength:'長度在 5 到 50 個字元',
    emailSpecialString:'電子郵件不能包含特殊字串'
  },
  home:{
    btnDevices:'設備控制',
    btnRoadcast:'廣播控制',
    btnResources:'存儲管理',
    btnLive:'直播控制',
    meetings:'會議預約',
    todaySchedule:'今日任務',
    allSkedules:'所有日程',
    details:'查看詳情',
    btnStart:'開始',
    titleContent:'你好，歡迎使用Q-NEX工作臺。接下來請跟隨新手指引瞭解我們',
    btnExit:'退出指引',
  },
  login: {
    checkPasswordTitleTwo: '請設置 6 位及以上的密碼，需包含字母和數字，可使用特殊符號（不限制）',
    captcha: '驗證碼',
    checkPasswordTitle: '密碼至少6位且不能為純數字',
    title: '歡迎回來',
    logIn: '登入',
    consoleLogin:'請登入',
    username: '登入名稱',
    password: '密碼',
    any: 'any',
    thirdparty: '其他登入方式',
    thirdpartyTips: 'Can not be simulated on local, so please combine you own business simulation! ! !',
    placeholder:["用戶名稱","密碼","驗證碼"],
    userNameTitle:'用戶名稱不正確!',
    forget:'忘記密碼',
    loginTitle0:'登入成功!',
    loginTitle1000:'用戶名稱或密碼錯誤!',
    loginTitle1001:'用戶名稱、密碼不能空白!',
    loginTitle1002:'驗證碼不能空白!',
    loginTitle1003:'用戶名稱不存在，登入失敗!',
    loginTitle1004:'驗證碼錯誤!',
    loginTitle1005:'未登入，請先登入!',
    loginTitle1006:'兩次輸入的密碼不一致!',
    loginTitleUserName:'用戶名稱不能空白!',
    loginTitlePwd:'密碼不能空白!',
    loginTitleVercode:'驗證碼不能空白!',
    titleLoginNameFormat:'帳號格式只能輸入字母和數字',
    privacy:'Q-NEX User Privacy Policy',
    privacyContent:"Agree to",
    '_zh':'中文(简体)',
    '_en':'_English',
    '_ko':'한국어',
    '_zh_ft':'中文(繁體)'
  },
  devices:{
    ptzCamera:'PTZ攝影機',
    start:'開始',
    stop:'停止',
    nmpPowerOff_mandatory:'NMP正在進行強制廣播',
    nmpPowerOff_nomandatory:'正在進行非強制廣播，是否執行？',
    nmpsPowerOff_mandatory:'當前有NMP設備正在進行強制廣播',
    nmpsPowerOff_nomandatory:'當前有NMP設備正在進行非強制廣播',

    reset:'重置',
    displayedInTheControlArea:'顯示在控制區',
    dragOrder:'拖動排列順序',
    areaSettingTwoNotice:'*RS232控制、空調控制、智能遙控根據後臺綁定情況判斷是否在控制區顯示',
    areaSettingThreeNotice:'*CBX的設備控制根據後臺綁定情況判斷是否在控制區顯示',
    controlSet:'控制區設定',
    vcbNoLine:'暫無CBX設備在線上',
    vcbNoBound:'暫無綁定CBX設備',
    tscNoBound:'TSC的RS232尚未綁定任何數據，請通知管理員前往儀表板進行綁定。',
    light:'電源控制',
    vcbpower:'電源',
    rs232Control:'串口控製',
    CBX:{
      powerSupplyON:'電源ON',
      powerSupplyOFF:'電源OFF',
      lockScreenON:'鎖定螢幕ON',
      lockScreenOFF:'鎖定螢幕OFF',
      childLockON:'兒童鎖ON',
      childLockOFF:'兒童鎖OFF',
      energySavingON:'節能ON',
      energySavingOFF:'節能OFF',
      signalSourceSwitchingON:'OPS',
      signalSourceSwitchingOFF:'Android',
      volumeAdjustment:'音量調節',
      brightAdjustment:'亮度調節',
      other:'其他...',
    },
    InterfaceOne:'介面一',
    InterfaceTwo:'介面二',
    abcStyleP:'抱歉，TSC和(NMP，MBX，NPS，NDP100，NDP500)不能同時選擇',
    masterControl:'主控',
    powerSupply:'電源',
    RecordingControl:'錄播控制',
    RecordingControlSystem:'錄播系統',
    LiquidCrystal:'液晶',
    projector:'投影儀',
    othertype:'其他',
    lockScreen:'鎖定螢幕',
    childLock:'兒童鎖',
    energySaving:'節能',
    signalSourceSwitching:'訊號來源切換',
    volumeAdjustment:'音量調節',
    brightAdjustment:'亮度調節',
    other:'其他',
    otherFunction:'功能',
    send:'發送',
    ON:'ON',
    OFF:'OFF',
    '_POWERA':'Display Power',
    '_POWERB':'External Power',
    '_MAGNETICLOCK':'電子鎖',
    '_HDMI1':'HDMI in 1',
    '_HDMI2':'HDMI in 2',
    '_HDMI3':'HDMI in 3',
    '_HDMIA':'HDMI out A',
    '_HDMIB':'HDMI out B',
    '_HDMIC':'HDMI out C',
    '_AIR':'空調',

    titleDevices:'按群組篩選:',
    content:'搜尋',
    selectALL:'全選',
    SelectRecentPage:'全選本頁',
    controlPanel:'控制區',
    displayInputSwitch:'視訊輸入切換',
    chooseINPUTSources:'選擇輸入來源',
    speakerVolume:'音頻音量',
    bass:'低音',
    treble:'高音',
    MICVolume:'麥克風音量',
    AirConditioning:'空調',
    model:'模式',
    setTemp:'溫度',
    fanSpeed:'風速',
    bold:'強風',
    projectionScreen:'投影布幕',
    electronicLock:'電子鎖',
    electronicLock1:'電子鎖',
    selectDevices:'請選擇至少一個設備',
    isCompelType:"該設備強制廣播不能進行設備控制！",
    mainPower:'總開關',
    extraPower:'電源控制',
    power:"主電源",
    hdmiBroadcast:'廣播',
    equipmentState1:'開機',
    equipmentState2:'關機',
    equipmentState3:'離線',
    main:'主控制',
    external:'外接設備',
    ProjectionScreen:'升降控制',
    UP:'升',
    DOWN:'降',
    LOCK:'鎖定',
    UNLOCK:'開鎖',
    PleaseDevice:'請選擇至少一臺設備',
    RemoteControl:'智能遙控',
    Action:'執行',
    Devicefilter:'設備篩選',
    DeviceStatus:'設備狀態',
    DeviceType:'類型',
    currentAudioSource:'當前音訊',
    audioSwitching:'音訊切換'
  },
  broadcast:{
    isBoarding:'（正在廣播中）',
    last3Days:'最近3天',
    last7Days:'最近7天',
    last30Days:'最近30天',
    historyRecord:'歷史記錄',
    SelectDestination:'1.選擇廣播目的地',
    BroadcastingConsole:'2.廣播設定',
    Notification:'文字廣播',
    btnStop:'停止',
    btnStart:'開始',
    Letters60:'(60字以內)',
    Letters300:'(300字以內)',
    LastingTime:'廣播時間長度:',
    Title:'標題:',
    Content:'內容:',
    Cannotquit:'強制廣播',
    ChooseMedia:'選擇多媒體檔案',
    Broadcasting:'多媒體廣播',
    dialogTitle:'聲音視訊資源',
    SortBy:'排序',
    btnBake:'返回上層',
    cancel: '取消',
    confirm: '確認',
    save:'儲存',
    coxAll:'全選',
    PublicCloud:'公用空間',
    IndividualCloud:'私人空間',
    selFile:'請選擇播放檔案或班級',
    StopBroadcast:'停止廣播',
    StartBroadcasting:'開始廣播',
    StopBroadcasting:'停止廣播',
    ForceQuit:'強制停止',
    PleaseMediaFile:'請選擇播放檔案',
    PleaseDevice:'請選擇播放目的地設備',
    broadcast_0:'開始廣播',
    broadcast_2500:'超出當前工作站可連接設備最大數量',
    broadcast_2501:'播放檔案錯誤',
    broadcast_2502:'播放結束',
    broadcast_2503:'無法獲取工作站資訊',
    broadcast_2510:'請注意!'+ '您當前為試用狀態，最多只可向三臺裝置發送廣播命令，請檢查您勾選的設備數量。',
    broadcast_2018:'服務被關閉',
    broadcast_2019:'服務已過期',
    broadcast_2512:'範本超出上限',
    broadcast_2513:'消防應急廣播',
    broadcast_2514:'請大家根據疏散示意圖，從安全出口方向、消防避難方向疏散到安全地方',
    broadcast_2006:'查詢不到設備 ',
    broadcast_2: '雲盤服務異常',
    broadcast_2515:'選擇設備中有未具有廣播功能的設備',
    broadcast_2516:'選擇的檔，超過NMP最大支持的解析度',
    broadcast_2517:'選擇的檔，超過NDP500最大支持的解析度',
    broadcast_Title:'設備廣播提醒',
    broadcast_TitleNDP500:'NDP500設備廣播提醒',
    broadcast_content:'廣播支持最高4K@30FPS; 最佳分辨率是1080P@30FPS。',
    broadcast_contentNDP500:'NDP500/600支持最高1080P@30FPS;最佳解析度為720P@30FPS。',
    broadcast_noSupported:'不支持以下視頻廣播：',
    broadcast_noSupportedNDP500:'NDP500/600不支持以下視頻廣播：',

  },
  resources:{
    uploadNameLengthError:'上傳檔案名稱不能超過100個字!',
    onUploadFile:'暫無等待上傳檔案',
    open:'展開',
    fold:'折疊',
    close:'關閉',
    PublicCloud:'公用空間',
    IndividualCloud:'私人空間',
    TransfersHistory:'歷史記錄',
    btnDownload:'下載',
    btnDelete:'刪除',
    btnUploadFile:'上傳',
    btnNewFolder:'新資料夾',
    btnBake:' 返回上層',
    coxAll:'全選',
    uploadError:'上傳檔案大小不能超過1G！',
    MD5:'校驗MD5',
    merge:'合併中',
    transcoding:'轉碼中',
    uploadFailed:'上傳失敗',
    fileError:'檔案讀取錯誤，請檢查該檔案',
    tableName:'檔案名稱',
    tableSize:'大小',
    tableType:'類型',
    tableTimeAdded:'新增時間',
    tableAction:'操作',
    btnRename:'重新命名',
    btnMoveTo:'移動到...',
    ClearAll:'清除全部',
    cancel: '取消',
    confirm: '確認',
    save:'儲存',
    addSuccess:'新增成功！',
    addError:'新增失敗!',
    editSuccess:'編輯成功！',
    editError:'編輯失敗!',
    delSuccess:'刪除成功！',
    delError:'刪除失敗!',
    diskError3000:'已超過公用空間大小，操作失敗！',
    diskError3001:'超過公用空間已使用大小，操作失敗！',
    diskError3002:'私人空間的使用量，已超過設定的大小，操作失敗！',
    diskError3003:'查詢不到數據，請檢查是否已綁定媒體庫！',
    diskError3004:'該資料夾名稱已存在！',
    diskError3005:'讀取資料夾失敗！',
    diskError3006:'同一層，創建目錄不能超過99個！',
    diskError3007:'存在相同的檔案名稱，修改失敗！',
    diskError3008:'存在相同的資料夾名稱，修改失敗！',
    diskError3009:'超過剩餘空間大小，上傳失敗！',
    diskError3010:'上傳私人空間失敗！',
    diskError3011:'檔案校驗失敗，請重新上傳！',
    diskError3012:'讀取私人空間網址失敗，操作失敗！',
    diskError3013:'多個檔案合併下載不能超過100M，超過限制請單個檔案下載！',
    diskError3014:'壓縮失敗，請重新選擇檔案下載！',
    diskError3015:'無此功能操作權限',
    downloadError:'下載失敗！',
    mobileError:'移動失敗！',
    root:'所有檔案',
    Name:'檔案名稱',
    Size:'大小',
    Type:'格式',
    uploadFile:'上傳檔案',
    newFolder:'新資料夾',
    tableTime:'更新時間',
    permission:'操作權限不足！',
    notifyTitle:'消息',
    notifyContent:'該用戶操作權限不足無法顯示!',
    sortFileName:'檔案名稱',
    sortTime:'按照時間',
    sortSize:'按照大小',
    sortType:'按照類型',
    moveTo:'移動到',
    test:'新資料夾',
    delTitle:'確定刪除?',
    delTitleContent:'所選內容將從資料庫中刪除。該操作無法復原，你確定要繼續嗎?',
    delCancelButton:'取消',
    delConfirmButton:'確認',
  },
  userMge:{
    userName:'姓名：',
    jobNumber:'工作id:',
    email:'電子郵件:',
    phone:'電話:',
    group:'群組:',
    oldPassword:'舊密碼:',
    newPassword:'新密碼:',
    confirmNewPassword:'確認新密碼:',
    btnSave:'儲存修改',
    titleChangePassword:'修改密碼',
    titleMyProfile:'個人資料',
    name:'昵稱:',
    error1400:'帳號(自定) 已經存在，操作失敗!',
    error1401:'帳號(系統產生) 已經存在，操作失敗!',
    error1402:'學校不存在，導入失敗！',
    error1403:'資料錯誤',
    error1404:'操作權限不足',
    selUser:'請選擇用戶！',
    error1405:'獲取身分失敗',
    error1406:'導入的用戶資料格式不正確',
    error1407:'電子郵件 已經存在，操作失敗',
    error1408:'電話 已經存在，操作失敗',
    editSuccess:'修改成功！',
    ChangePassword:'修改密碼',
    UserPrivacyAgreement:'用戶隱私權協議'
  },
  information:{
    '_2602':' 設備離線',
    '_2603':' 廣播失敗',
    '_2604':' 廣播被切斷',
    '_2605':' 空間已滿',
    '_2606':' 分鐘前',
    '_2607':' 小時前',
    '_2609':' 出現故障,請',
    '_2609_a':' 點擊此處',
    '_2609_time':'及時處理',
    userType:'超級管理員',
    unreadNoticeFirst:'未讀消息優先',
    sortByTime:'按時間排序',
    coxRead_0:'未讀',
    coxRead_1:'已讀',
    allCoxRead:'全部標識為已讀',
    load:'下載中...',
    noData:'沒有更多資料了',
    viewALLMessages:'查看全部消息'
  },
  input:{
    thisField:'此項為必填項.',
    titleShooleNub60:'60字以內',
    titleShooleNub300:'300字以內',
    select:'請選擇',
    Offline:'離線'
  },
  schedule:{
    OnlyManual:'僅顯示手動任務',
    runStartNow:'立即執行任務',
    runStopNow:'停止任務執行',
    tackExecutionStart:'任務開始執行',
    tackExecutionStop:'任務停止執行',
    dehumidification:'除湿',
    airSupply:'送風',
    masterControl:'主控：',
    powerSupply:'電源',
    RecordingControl:'錄播控制',
    RecordingControlSystem:'錄播系統',
    LiquidCrystal:'液晶',
    projector:'投影儀',
    othertype:'其他',
    lockScreen:'鎖定螢幕',
    childLock:'兒童鎖',
    energySaving:'節能',
    signalSourceSwitching:'訊號來源切換',
    other:'其他功能：',
    otherFunction:'功能',
    send:'發送',
    ON:'開',
    OFF:'關',
    btnAddSchedule:'恢復清單',
    EditSchedulelist:'修改清單',
    AddSchedulelist:'新建清單',
    RestoreSchedulelist:'恢復清單',
    btnCancel:'取消',
    btnNewList:'新建清單',
    ListName: '清單名稱',
    Cannotquit:'強制廣播',
    NOCannotquit:'非強制廣播',
    ListValidityPeriod: '清單有效期',
    ListDescription: '清單描述',
    currentSchedule:'最近清單',
    historySchedule:'歷史清單',
    selectTime:'時間:',
    selectTimeTable:'時間',
    taskType:'任務類型:',
    selectBroadcasting:'廣播控制',
    selectDeviveControl:'設備控制',
    newSchedule:'新建任務',
    newChecklist:'新建清單',
    titleStatus:'狀態',
    titleType:'類型',
    titleStartTime:'開始時間',
    titleEndTime:'結束時間',
    titleRepeat:'重複方式',
    titleName:'任務名稱',
    titleAction:'操作',
    tableEnabled:'啟用',
    tablePaused:'停止',
    tableEdit:'修改',
    tableDelete:'刪除',
    tableVolumeEdit:'廣播音量',
    tableBroadcastTitle:'廣播標題',
    tableBroadcastContent:'廣播內容',
    tableBroadcastList:'廣播列表',
    tableBroadcast:'廣播方式',
    btnRemoveCompletely:'Remove completely',
    btnEnabled:'啟用任務',
    btnPaused:'停用任務',
    btnDelete:'刪除',
    repeat0:'週一',
    repeat1:'週二',
    repeat2:'週三',
    repeat3:'週四',
    repeat4:'週五',
    repeat5:'週六',
    repeat6:'周日',
    dialogTitleAdd:'新建設備控制',
    dialogTitleEdit:'修改設備控制',
    newBroadcastingSchedule:'新建廣播任務',
    editBroadcastingSchedule:'修改廣播任務',
    chooseDevice:'選擇目標設備',
    timeSetting:'時間設置',
    controlBroadcasting:'廣播選項',
    controlOption:'控制選項',
    scheduleName:'任務名稱:',
    destination:'目標設備:',
    timeTilte:'開始時間:',
    repeatTitle:'重複選項:',
    dialogRepeat0:'週一',
    dialogRepeat1:'週二',
    dialogRepeat2:'週三',
    dialogRepeat3:'週四',
    dialogRepeat4:'週五',
    dialogRepeat5:'週六',
    dialogRepeat6:'周日',
    dialogOnceType:'一次',
    dialogRepeatType:'多次',
    Manual:'手動',
    ManualContent:'設定完成後，您可以手動執行這些任務。',
    mainPower:'主電源',
    powerControl:'電源控制',
    tableDisplayInputSwitch:'視訊輸入切換',
    tableAirConditioning:'空調',
    tableProjectionScreen:'投影布幕',
    tableElectronicLock:'電子鎖',
    interactiveFlatPanel:'Interactive Flat Panel',
    displayInputSwitch:'視訊輸入切換：',
    speakerVolume:'音頻音量',
    MICVolume:'麥克風音量',
    ProjectionScreen:'投影布幕：',
    ElectronicLock:'電子鎖：',
    AirConditioning:'空調',
    AirConditioningPower:'電源:',
    AirConditioningModel:'模式:',
    AirConditioningTEMP:'溫度:',
    AirConditioningFanSpeed:'風速：',
    OPEN:'開',
    CLOSE:'關',
    UP:'升',
    DOWN:'降',
    PowerOFF:'關',
    PowerON:'開',
    ModelAuto:'自動',
    ModelCool:'冷氣',
    ModelHeat:'暖氣',
    ModelAir:'強風',
    TEMPLow:'低',
    TEMPMiddle:'中',
    TEMPHigh:'高',
    btnSave:'儲存',
    btnNext:'下一步',
    StartTime:'開始時間',
    StopTime:'結束時間',
    Mandatory:'是否強制廣播',
    Video:'視訊廣播',
    Notification:'文字廣播',
    btnFile:'選擇媒體檔案',
    LastingTime:'Lasting Time',
    textTitle:'標題:',
    textContent:'內容:',
    textTitleLetters:'60字以內',
    textContentLetters:'320字以內',
    CannotquitYES:'是',
    CannotquitNo:'否',
    YES:'YES',
    No:'No',
    delTitleContent:'刪除任務清單？',
    delTitleListContent:'刪除的任務清單將移動到歷史清單中，可在歷史清單中恢復',
    deleListTitle:'刪除任務清單？',
    delTitleListContent1:'刪除任務清單將導致與其相關的任務都被清除，請確認。',
    deleListTitle1:'確定刪除該任務清單？',
    delTitle:'確定刪除?',
    btnConfirm:'確認',
    coxAll:'所有任務',
    coxBroadcasting:'廣播控制',
    coxDeviveControl:'設備控制',
    rdMandatory:'強制',
    noRdMandatory:'非強制',
    startDate:'開始日期',
    endedDate:'結束日期',
    or:'-',
    broadcastingType:'廣播類型',
    ChooseTime:'選擇時間',
    ChooseDate:'選擇日期',
    newScheduleList:'新建清單',
    editScheduleList:'修改清單',
    listName:'清單名稱',
    listValidityPeriod:'清單有效期',
    listDescription:'清單描述',
    cancel: '取消',
    confirm: '確認',
    save:'儲存',
    addSuccess:'新增成功！',
    addError:'新增失敗!',
    editSuccess:'編輯成功！',
    editError:'編輯失敗!',
    delSuccess:'刪除成功！',
    delError:'刪除失敗!',
    restoreSuccess:'清單已恢復',
    restoreError:'清單失敗',
    restoreTitleContent:'該時間與清單內時間衝突，請重新選擇',
    Enabled:'啟用',
    Paused:'停止',
    Title:'標題:',
    Content:'內容:',
    errorScheduleNameRequired:'任務名稱不能空白',
    errorDeviceRequired:'請選擇目標設備',
    deleTitle:'確定刪除該任務？',
    loopList:'列表循環',
    errorPleaseDateRange:'請選擇日期區間',
    'addError_2009':'清單名稱重複',
    conflicts:'與以下任務時間衝突：',
    Pleaseagain:'請重新輸入',
    errorScheduleName:'任務名稱',
    errorListName:'清單名稱',
    'today':'今天',
    'yesterday':'昨天',
    'thisWeek':'本周',
    'lastWeek':'上周',
    'lastMonth':'上月',
    'thisMonth':'本月',
    'times':'次數',
    TimeConflicts:'時間衝突',
    'editError_2006':'查詢不到設備 ',
    'editError_2010':'任務名稱重複',
    'editError_2100':'任務已過期，啟用失敗。',
    ListTimeExpired:'清單時間已過期，請重新選擇',
    TimeExpired:'時間已過期',
    ControlOption:'控制選項未填',
    Pleaseleastone:'請選擇控制選項內容',
    Enter:'請輸入內容',
    TitleFilled:'請填寫標題',
    ContentFilled:'請填寫內容',
    PleaseMediaFile:'請選擇檔',
    PleaseSchedule:'請選擇要操作任務',
    delTitleScheduleContent:'刪除的任務無法恢復',
    deleTitleSchedule:'確定刪除任務嗎？',
    deleteScheduleTitle:'請選擇要刪除的任務',
    PleaseFillColumn:'請填寫清單名稱',
    PleaseDate:'請選擇日期',
    Previous:'上一步',
    RemoteControl:'智能遙控',
    taskhasexpired:'此內容已過期，請聯繫建立人員更新時間',
    execute:'執行',
    broadcastingList:'播放列表',
    volumeSuccess:'音量設定成功',
    volumeFailed:'音量設定失敗',
  },
  live:{
    StreamingRoom:'直播間',
    btnAddNewRoom:' 新直播間',
    Steaming:'直播中',
    Creater:'主播:',
    Address:'RTMP 網址:',
    StreamingURL:'直播觀看網址:',
    DestinationNMP:'選擇直播目的地設備:',
    stop:'停止',
    stat:'開始直播',
    btnCope:'複製連結',
    QRcode:'二維碼',
    Refresh:'重新載入',
    AddNewRoomTitle:'建立新直播間',
    editNewRoomTitle:'修改新直播間',
    roomName:'直播間名稱:',
    cancel: '取消',
    confirm: '確認',
    save:'儲存',
    delTitleContent:'確認要刪除該直播間嗎? 本操作無法復原。',
    delTitle:'要刪除嗎?',
    delConfirmButton:'確認',
    delCancelButton:'取消',
    addSuccess:'新增成功！',
    addError:'新增失敗!',
    editSuccess:'編輯成功！',
    editError:'編輯失敗!',
    delSuccess:'刪除成功！',
    delError:'刪除失敗!',
    Stopstreaming:'直播開始',
    Startstreaming:'直播停止',
    error2504:'無法獲取工作站直播網址',
    error2505:'直播房間名稱重複',
    error2506:'直播設備已被其他直播佔用',
    error1900:'讀取的資料空白',
    error2503:'無法獲取工作站資訊',
    error2507:'直播網址重複',
    copySuccess:'複製成功',
    copyError:'該流覽器不支援自動複製',
    flashControl:'您尚未安裝/驅動Flash控制件，請安裝/驅動Flash控制件後再試',
    liveStreaming:'未找到直播視訊，先休息一下',
    btnflash:'安裝/執行',
    serverAddress:'伺服器網址',
    addressKey:'密碼:',
    watchingAddress:'觀看網址',
    audioOnly:'僅音訊廣播',
    enterTheKey:'密碼不可空白'
  },
  privacy:{
      PrivacyPolicy:'Q-NEX隱私政策',
      Byusing:'您使用 Q-NEX 服務，即表示您信賴我們對您的資訊的處理方式。我們深知這項責任事關重大，因此一直致力於保護您的資訊，並讓您擁有控制權。',
      whatinformation:'本隱私權政策旨在協助您瞭解我們會收集哪些資訊、為什麼收集這些資訊，以及您如何管理自己的資訊。',
      EffectiveDate:'生效日期：2020年1月1日',
      title1:'小奇智聯尊重您的隱私',
      title1Respects1:'銳達互動科技股份有限公司及其子品牌小奇智聯（統稱為“小奇智聯”，“ Q-NEX”或“我們”）尊重您的隱私，並瞭解您的個人數據的處理和安全對您很重要。請查看下麵的完整隱私政策，以獲取有關我們如何收集，使用，共用和保護您的個人數據的更完整詳細資訊，以及您在使用和共用您的個人數據方面的選擇以及其他重要注意事項。',
      title1Respects2:'本隱私政策解釋了Q-NEX在處理（例如收集，使用，存儲，複製或披露）您的個人數據方面的做法：（i）通過我們的網站https://www.qnextech.com（“網站”） ，電子郵件，其他書面或親自交流； （ii）在與客戶，最終用戶，經銷商，分銷商，供應商，承包商，代理商或代表的所有商業關係範圍內； （iii）在任何其他潛在業務關係的正常情況下。我們承諾遵守法律法規規定的義務，如下所述，包括但不限於《電信和互聯網用戶個人資訊保護規定》，並在我們處理您的個人數據時尊重您的權利。',
      title2:'隱私和數據保護',
      title2Respects1:'“個人數據”是指識別或可用於識別個人的任何資訊。',
      title2Respects2:'“隱私和數據保護法”是指在中國境內、以及中國境外任何地方，省，州，聯邦或國家級別上與數據隱私，數據安全和/或個人數據保護有關的任何和/或所有法律，規則，指令和法規。其中，中國境外法律法規包括但不限於：（a）通用數據保護條例（GDPR）及其每個歐盟成員國在本國的實施情況； （b）1988年《澳大利亞隱私法》（聯邦）和《澳大利亞隱私修正案（增強隱私保護法）》（2012年）； （c）1992年12月8日的《比利時隱私法》； （d）《加拿大個人資訊保護和電子文檔法》，SC 2000，c 5（PIPEDA）； （e）《 2012年新加坡個人資料保護法》（PDPA）； （f）適用於數據當事人所在地的其他隱私和數據保護法律； （g）適用的任何後續法規。',
      title3:'我們何時收集您的個人數據？',
      title3Respects1:'在以下情況下，當您通過電話，電子郵件，網站或其他方式與我們通信時，Q-NEX可能會收集您的個人數據：',
      title3a:'流覽我們的網站或訪問我們的社交媒體網站；',
      title3b:'與Q-NEX通訊；',
      title3c:'參觀我們的辦公室，活動或設施；',
      title3d:'註冊/參加我們的會議，活動，培訓或其他活動；',
      title3e:'要求提供資訊，支持，服務，材料，協助或其他查詢；',
      title3f:'訂閱新聞通訊或其他郵件清單；',
      title3g:'交換名片；',
      title3h:'填寫網站聯繫表，問卷，調查或競賽報名表或以其他方式參加這些活動；',
      title3i:'從事商業關係或其他合作；',
      title3j:'訂購或註冊Q-NEX產品；',
      title3k:'創建或註冊帳戶；;',
      title3l:'上載或下載檔；',
      title3m:'V驗證您作為數據主體的身份；',
      title3n:'使用連接到Internet的Q-NEX產品，包括移動應用程式，雲平臺和某些硬體設備。',
      title4:'我們收集哪些類型的個人數據？',
      title4Respects1:'Q-NEX可能會收集以下個人數據：',
      title4a:'姓名，姓氏，職稱，公司，電子郵件地址，電話號碼（手機和座機），地址，簽名和其他聯繫資訊；',
      title4b:'IP地址；',
      title4c:'位置數據；',
      title4d:'Cookie ID；',
      title4e:'語言；',
      title4f:'關於通訊/產品和服務的個人偏好；',
      title4g:'財務詳細資訊（例如付款資訊，銀行帳號和信用資訊）；',
      title4h:'有關使用Q-NEX產品和服務的專案的個人數據；',
      title4i:'您提交，回應和回饋中提供的個人數據；',
      title4j:'有關您與Q-NEX互動的個人數據，包括您對網站和Q-NEX產品或服務的使用；',
      title4k:'社交媒體數據，圖像，照片和照相機鏡頭；',
      title4l:'您或您的Q-NEX授權經銷商或服務提供商提供的任何其他個人數據。',
      title4Respects2:'為避免疑義，Q-NEX不會收集任何敏感的個人數據，例如種族或民族血統；政治觀點；宗教或哲學信仰；遺傳特徵健康資訊；性偏好；有關兒童的資訊；刑事定罪;或生物識別數據，我們明確要求您不要在您對我們的回應或回饋中向我們提供此類數據。',
      title5:'我們如何使用您的個人數據？',
      title5Respects1:'為了更好地管理我們自己的業務需求並更好地與您溝通，我們可能出於以下目的收集，分析，使用和處理您的個人數據：',
      title5a:'答復您的詢問，問題和其他要求；',
      title5b:'優化和管理我們網站的品質和內容，包括個性化和保護您的網站體驗的能力；',
      title5c:'創建和維護您的網站，客戶和產品帳戶以及註冊；',
      title5d:'為您提供行銷，廣告，促銷，計畫，優惠和其他機會；包括時事通訊，有關產品和服務的資訊，訂閱，培訓，更新和直接行銷（可能根據您的通信偏好而有針對性）；',
      title5e:'進行顧客滿意度研究，調查和其他市場研究；',
      title5f:'管理我們的活動和活動，並邀請您參加活動；',
      title5g:'註冊來訪我們辦公室，設施和活動的訪客；',
      title5h:'製作宣傳材料，包括有關專案或活動的視頻，照片，文章，案例研究，新聞通訊和其他材料；',
      title5i:'提供產品，服務，培訓，技術支持，客戶服務和其他協助；',
      title5j:'管理和履行我們的協議和義務；',
      title5k:'對業務線索，機會和聯繫做出回應並採取後續行動；',
      title5l:'處理付款，訂單，發票，退貨，托收和其他要求；',
      title5m:'提供我們產品和服務的價格，報價和定制配置；',
      title5n:'授權您訪問我們的軟體，培訓，技術資訊和其他專有內容；',
      title5o:'評估，故障排除，分析和改善我們產品，服務，培訓，技術支持和客戶服務的使用，功能，功能和性能；',
      title5p:'收集，分析和維護有關我們產品和服務的配置和備份數據；',
      title5q:'促進有關我們的產品和服務的計畫，分析，預測和報告；',
      title5r:'用於我們的內部業務運營和流程，包括業務和財務記錄保存，數據管理和業務連續性；',
      title5s:'履行我們的法律和法規義務。',
      title6:'哪種法律依據適用於我們處理您的個人數據？',
      title6Respects1:'為了上述目的，以下法律依據可能適用於您的個人數據處理：',
      title6a:'為履行您與我們之間的協議或採取所有合同前步驟，必須進行處理；',
      title6b:'處理是基於我們的合法利益（遵守義務，維護業務記錄，防止欺詐，網路和資訊安全等）進行的。在進行此類處理時，我們力求在這種合法利益與尊重您的隱私之間取得平衡。',
      title6c:'您已同意處理（例如，在直接行銷的情況下，用於處理分析Cookie以及將數據傳輸給第三方）；',
      title6d:'為了使我們遵守我們的法律義務（例如稅務管理和記錄保留）；要麼',
      title6e:'在非常特殊的情況下保護您或他人的切身利益。',
      titel7:'我們向誰披露您的個人數據？',
      title7Respects1:'Q-NEX可能向您自己，Q-NEX的關聯公司或第三方披露您的個人數據，例如支付提供商，軟體提供商，合作夥伴，運輸合作夥伴，金融機構，保險公司，法律服務或某些其他服務提供商或與Q-NEX建立戰略關係的合作夥伴，以便以最有效的方式實現我們與您的關係。',
      title7Respects2:'Q-NEX不會將您出於本隱私政策中所述目的以外的目的提交的任何個人數據透露給第三方。如果將來我們打算出於除本隱私政策所述目的以外的任何目的向第三方披露您的個人數據，我們將提前通知您，並在需要時征得您的同意。',
      title7Respects3:'儘管有上述規定，在法律要求下、在法律程式中，或如出於善意，Q-NEX認為您有必要採取行動以遵從法規，Q-NEX將向第三方（例如主管當局）披露您的個人數據遵守某些法律，法規或規章。',
      titel8:'如果進行國際數據傳輸，我們提供哪些保證？',
      title8Respects1:'Q-NEX是一家全球性公司，我們可能會將您的資訊轉移給代表我們在全球範圍內的Q-NEX分支機構，代表或第三方承包商。每個分支機構，代表或第三方承包商都與Q-NEX密切合作，這些關聯實體之間的任何個人數據傳輸都將遵守適用的隱私和數據保護法。',
      title8Respects2:'如果將歐洲經濟區（EEA）居民的個人數據轉移給位於EEA以外國家/地區的個人或實體時，被認為未提供足夠的保護，我們將制定資訊安全性更強，更適當的合同條款以加強數據保護。為確保對EEA居民個人數據的任何此類傳輸均符合適用的《隱私和數據保護法》，我們將（i）根據歐盟示範協議簽訂數據傳輸協議，（ii）採用具有約束力的公司規則，（iii）依靠法律確定的例外情況（例如請求您的明確同意），或（iv）採用被認為可以為您的個人數據提供充分保護的其他機制。',
      titel9:'我們如何保護您的個人數據？',
      title9Respects1:'根據行業標準，我們使用各種安全技術和預防措施，例如安全套接字（SSL）協議（加密），以幫助保護您的個人數據免於丟失，被盜，濫用和未經授權的訪問。 為了保護存儲在Q-NEX伺服器或基於雲的存儲上的任何個人數據，我們會定期監視我們的系統是否存在漏洞或攻擊，並實施最新的資訊安全措施。',
      title9Respects2:'Q-NEX處理的個人數據的訪問僅限於需要瞭解該資訊以及代表Q-NEX根據本隱私政策處理該資訊的員工，承包商和下屬組織，並且未同意透露給他人。',
      titel10:'我們將保留您的個人數據多長時間？',
      title10Respects1:'除非法律要求更長的保留期，否則Q-NEX將在實現本隱私政策中所述的相關目的的期間保留您的個人數據。',
      titel11:'Cookies的使用',
      title11Respects1:'Q-NEX在我們的網站上使用cookie，既可以使網站正常工作，又可以改善您訪問我們網站時的體驗。 Cookie檔存儲在您電腦的硬碟驅動器上，使我們能夠獲取有關您對我們網站使用情況的資訊，以及衡量和改善我們網站的性能。 Cookies使您能夠存儲您的首選項，以使我們的網站在您流覽我們的網站時能夠識別這些首選項。',
      title11Respects2:'您可以通過啟動流覽器上允許您拒絕cookie的設置來拒絕接受cookie。但是，如果選擇此設置，則可能無法訪問我們網站的某些部分或功能。除非您已調整流覽器設置以使其拒絕Cookie，否則您每次登錄我們的網站時，我們的系統都會向您的電腦發佈Cookie。',
      title11Respects3:'首次訪問我們的網站時，您會獲得此cookie政策的鏈接，並有機會更改流覽器設置以拒絕cookie。在不更改設置的情況下繼續流覽我們的網站，即表示您同意我們按照本政策中的說明使用Cookie。',
      title11Respects4GoogleAnalytics:'Google Analytics。',
      title11Respects4:'我們使用行業標準的網路分析來跟蹤對我們網站的訪問，即Google Analytics（分析）提供的訪問。 Cookies生成的有關您使用我們網站的資訊（包括您的IP地址）將傳輸到Google Analytics（分析）並存儲在其伺服器上，並根據Google的隱私權政策進行處理，可通過以下鏈接訪問：https： //policies.google.com/privacy。',
      titel12:'我們網站上的第三方鏈接',
      title12Respects1:'Q-NEX網站包含其他網站的鏈接。 Q-NEX對其他網站的隱私政策或其存儲，使用或分發資訊的方式不承擔任何責任。 Q-NEX鼓勵您查看您可能訪問的任何網站的隱私政策。',
      titel13:'兒童資訊',
      title13Respects1:'Q-NEX的網站不適合兒童使用，其產品和服務也不出售給兒童。 根據《兒童個人資訊網絡保護規定》，我們不會從已知的18歲以下人士那裏收集或維護資訊，並且本網站的任何部分均不旨在吸引18歲以下的任何人。',
      titel14:'您的權利是什麼？如何行使這些權利？',
      title14Respects1:'如果您是自然人，則您有權隨時獲知我們處理的有關您的個人數據，並在適用的《電信和互聯網用戶個人資訊保護規定》授權的範圍內，有權要求訪問，修改，限制使用，個人資訊的傳輸，刪除或反對處理您的個人數據，但以適用的隱私和數據保護法為准。',
      title14Respects2:'如果處理完全基於您的同意，那麼您也有權隨時撤回您的同意，而不會影響撤銷前處理的合法性。',
      title14Respects3:'通過以下列出的聯繫方式，您可以對Q-NEX處理您的個人數據行使上述權利，除非這需要Q-NEX做出超格的努力。',
      title14Respects4:'如果您對個人數據或行使上述權利有任何其他疑問，請隨時使用下麵列出的聯繫資訊，我們將竭誠為您服務。',
      title14Respects5:'如果您與我們聯繫以行使適用的隱私和數據保護法中的一項權利，我們將在一（1）個月內答復。在某些特殊情況下，我們最多可能需要三（3）個月才能完全答復您，但在這種情況下，我們會在最初答復中告知您為什麼我們需要更多時間來答復。',
      title14Respects6:'如果我們無法解決查詢或請求，則您可能有權向當地數據保護機構投訴。',
      titel15:'隨時瞭解我們的隱私政策的變化',
      title15Respects1:'在技術和法規不斷變化的世界中，本隱私政策也可能會發生變化。 我們邀請您始終查閱https://www.qnextech.com/legal上發佈的本政策的最新版本，如果有任何更改，我們將通過我們的網站或其他常用通信管道通知您。',
      titel16:'聯繫Q-NEX',
      title16Respects1:'如果您對此隱私政策或Q-NEX收集，使用/處理您的個人數據的方式有疑問/評論，請與我們聯繫：',
      title16Respects2:'通過電子郵件：info@qnextech.com',

  },
  guidepages:{
    next:'下一步-控制設備',
    next1:'下一步-控制設備',
    next2:'下一步-廣播控制',
    next3:'下一步-開始廣播',
    next4:'下一步-停止廣播',
    next5:'下一步-文字廣播',
    next6:'下一步-任務設定',
    next7:'下一步-建立任務',
    next8:'下一步-歷史清單',
    next9:'下一步-空間管理',
    next10:'下一步-直播控制',
    next11:'下一步-設定直播',
    exit:'退出',
    guideContent:'指引目錄',
    btnHomepage:'首頁',
    btnDevices:'設備控制',
    btnBroadcast:'廣播控制',
    btnSchedule:'任務控制',
    btnResources:'存儲管理',
    btnStreaming:'直播管理',
    btnPrevious:'上一步'

  }
}



// WEBPACK FOOTER //
// ./src/lang/zh-ft.js